import { useMutation } from '@tanstack/react-query';
import { terminateParkingContract } from '../../api/parking-contract.ts';
import type { TerminateParkingContractRequest } from '../../api/requests/parking-contract-request.ts';

export default function useTerminateParkingContract() {
  return useMutation({
    mutationFn: (request: TerminateParkingContractRequest) =>
      terminateParkingContract(request),
  });
}
